<template>
  <div>
    <ActionBar :dismissible="mode === 'detail'" @dismiss="dismiss">
      <el-button v-if="mode === 'detail'" slot="action" type="primary" icon="el-icon-edit" @click="edit">
        แก้ไข
      </el-button>
      <template v-else>
        <el-button slot="action" type="danger" plain @click="cancel">
          ยกเลิก
        </el-button>
        <el-button slot="action" type="primary" @click="save">
          บันทึก
        </el-button>
      </template>
      <ActionBarTitle>{{ title }}</ActionBarTitle>
    </ActionBar>

    <page-container>
      <app-container>
        <el-card>
          <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-row type="flex">
              <el-col :md="{ span: 16, offset: 4 }">
                <div class="c-customer-create__header">
                  <image-upload :file.sync="form.profilePicture.file" :src="form.profilePicture.src"
                    :readonly="mode === 'detail'" class="c-customer-create__image-upload"></image-upload>
                  <div v-if="mode !== 'detail'">Profile Picture</div>
                </div>

                <el-row type="flex" :gutter="32" :style="{ flexWrap: 'wrap' }">
                  <el-col :sm="12" class="c-customer-create__section-col">
                    <h2 class="c-customer-create__section-heading">
                      1. ข้อมูลพื้นฐาน
                    </h2>
                    <div class="c-customer-create__section-content">
                      <el-form-item label="ชื่อ" prop="firstName">
                        <el-input v-model="form.firstName" :readonly="mode === 'detail'"></el-input>
                      </el-form-item>
                      <el-form-item label="นามสกุล" prop="lastName">
                        <el-input v-model="form.lastName" :readonly="mode === 'detail'"></el-input>
                      </el-form-item>
                      <el-form-item label="เพศ" prop="gender">
                        <el-row type="flex" :gutter="32" :style="{ flexWrap: 'wrap' }">
                          <el-col :sm="12" :style="{ marginBottom: '0.5rem' }">
                            <el-radio v-model="form.gender" label="M" border :disabled="
                                mode === 'detail' && form.gender !== 'M'
                              " class="c-customer-create__radio">
                              <i class="el-icon-male c-customer-create__radio-icon"></i>
                              Male
                            </el-radio>
                          </el-col>
                          <el-col :sm="12" :style="{ marginBottom: '0.5rem' }">
                            <el-radio v-model="form.gender" label="F" border :disabled="
                                mode === 'detail' && form.gender !== 'F'
                              " class="c-customer-create__radio">
                              <i class="el-icon-female c-customer-create__radio-icon"></i>
                              Female
                            </el-radio>
                          </el-col>
                        </el-row>
                      </el-form-item>
                      <el-form-item label="วันเกิด" prop="birthDate">
                        <el-date-picker v-model="form.birthDate" type="date" placeholder="กรุณาเลือกวันเกิด"
                          :readonly="mode === 'detail'" :style="{ width: '100%' }"></el-date-picker>
                      </el-form-item>
                      <el-form-item label="เลขที่บัตรประชาชน" prop="idCardNumber">
                        <el-input v-model="form.idCardNumber" placeholder="เช่น 31018293827382" :maxlength="13"
                          :readonly="mode === 'detail'"></el-input>
                      </el-form-item>
                      <el-form-item label="เบอร์ติดต่อ" prop="tel">
                        <el-input v-model="form.tel" type="tel" placeholder="0848475744" :maxlength="10"
                          :readonly="mode === 'detail'"></el-input>
                      </el-form-item>
                      <el-form-item label="อีเมล" prop="email">
                        <el-input v-model="form.email" type="email" placeholder="Email"
                          :readonly="mode === 'detail'"></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :sm="12" class="c-customer-create__section-col">
                    <h2 class="c-customer-create__section-heading">
                      2. ที่อยู่
                    </h2>
                    <div class="c-customer-create__section-content">
                      <el-form-item label="ที่อยู่" prop="address">
                        <el-input v-model="form.address" type="textarea" placeholder="บ้านเลขที่, อาคาร, ถนน"
                          :autosize="{ minRows: 3 }" :readonly="mode === 'detail'"></el-input>
                      </el-form-item>
                      <el-form-item label="แขวง/ตำบล" prop="subdistrict">
                        <el-autocomplete v-model="form.subdistrict" clearable :fetch-suggestions="querySubdistrict"
                          :disabled="mode === 'detail'" :style="{ width: '100%' }" @select="handleSubdistrictSelect"
                          @blur="handleSubdistrictBlur" @clear="handleSubdistrictClear">
                          <template v-slot="{ item }">
                            {{ item.subdistrict }}, {{ item.district }},
                            {{ item.province }}, {{ item.postalCode }}
                          </template>
                        </el-autocomplete>
                      </el-form-item>
                      <el-form-item label="เขต/อำเภอ">
                        <el-input :value="location && location.district" disabled></el-input>
                      </el-form-item>
                      <el-form-item label="จังหวัด">
                        <el-input :value="location && location.province" disabled></el-input>
                      </el-form-item>
                      <el-form-item label="รหัสไปรษณีย์">
                        <el-input :value="location && location.postalCode" disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </app-container>
    </page-container>
  </div>
</template>

<script>
import moment from 'moment'
import { LocationService, CustomerService } from '@/services'
import { useLoading } from '@/use/loading'
import {
  ActionBar,
  //ActionBarButton,
  ActionBarTitle
} from '@/components/ui/action-bar'
import { AppContainer } from '@/components/ui/container'
import { PageContainer } from '@/components/page/page-container'
import ImageUpload from '@/components/page/ImageUpload.vue'
import { back } from '@/utils/navigation'

export default {
  components: {
    ActionBar,
    //ActionBarButton,
    ActionBarTitle,
    PageContainer,
    AppContainer,
    ImageUpload
  },

  data() {
    return {
      form: {
        profilePicture: {
          file: null
        },
        firstName: '',
        lastName: '',
        gender: '',
        birthDate: null,
        idCardNumber: '',
        tel: '',
        email: '',
        address: '',
        subdistrict: ''
      },

      location: null,

      fetchedData: null,

      rules: {
        firstName: [
          { required: true, message: 'กรุณากรอกชื่อ', trigger: 'blur' }
        ],
        idCardNumber: [
          {
            pattern: /^\d{13}$/,
            message: 'รูปแบบเลขที่บัตรประชาชนไม่ถูกต้อง',
            trigger: 'blur'
          }
        ],
        tel: [
          { required: true, message: 'กรุณากรอกเบอร์ติดต่อ', trigger: 'blur' },
          {
            pattern: /^\d+$/,
            message: 'กรุณากรอกเป็นตัวเลขเท่านั้น',
            trigger: 'blur'
          }
        ],
        email: [
          { type: 'email', message: 'รูปแบบอีเมลไม่ถูกต้อง', trigger: 'blur' }
        ]
      }
    }
  },

  computed: {
    mode() {
      return {
        CustomerCreate: 'create',
        CustomerEdit: 'edit',
        CustomerDetail: 'detail'
      }[this.$route.name]
    },
    title() {
      return {
        create: 'สร้างลูกค้าใหม่',
        edit: 'แก้ไขข้อมูลลูกค้า',
        detail: 'รายละเอียดลูกค้า'
      }[this.mode]
    }
  },

  created() {
    if (['edit', 'detail'].includes(this.mode)) {
      this.fetchCustomer()
    }
  },

  methods: {
    async fetchCustomer() {
      const loading = useLoading()

      try {
        await CustomerService.getDetail(this.$route.params.id).then(res => {
          const { data } = res

          if (data.status === 'error') throw new Error(data.message.detail)

          const { result } = data

          this.fetchedData = result

          this.form = {
            profilePicture: {
              src: result.image.medium
            },
            firstName: result.first_name || '',
            lastName: result.last_name || '',
            gender: result.gender || '',
            birthDate: result.birthdate ? new Date(result.birthdate) : null,
            idCardNumber: result.id_card_number || '',
            tel: result.phone || '',
            email: result.email || '',
            address: result.address || '',
            subdistrict: result.subdistrict
              ? result.subdistrict.subdistrict.name_th
              : ''
          }

          if (result.subdistrict) {
            this.location = {
              id: result.subdistrict.subdistrict.id,
              subdistrict: result.subdistrict.subdistrict.name_th,
              district: result.subdistrict.district.name_th,
              province: result.subdistrict.province.name_th,
              postalCode: result.subdistrict.subdistrict.zip_code
            }
          }
        })
      } finally {
        loading.close()
      }
    },

    nextRoute() {
      switch (this.$route.query.ref) {
        case 'sell':
          back({ name: 'SellCreate' })
          break

        case 'buy':
          back({ name: 'BuyCreate' })
          break

        case 'trade':
          back({ name: 'TradeCreate' })
          break

        case 'pawn':
          back({ name: 'PawnCreate' })
          break

        default:
          back({ name: 'Customer' })
      }
    },

    async save() {
      const formData = new FormData()
      formData.set('first_name', this.form.firstName)
      formData.set('last_name', this.form.lastName)
      formData.set('email', this.form.email)
      formData.set('phone', this.form.tel)
      formData.set('address', this.form.address)
      formData.set('gender', this.form.gender || 'U')
      formData.set('subdistrict', this.location ? this.location.id : '')
      formData.set('note', '')
      formData.set('id_card_number', this.form.idCardNumber)
      formData.set(
        'birthdate',
        this.form.birthDate ? moment(this.form.birthDate).format('Y-MM-DD') : ''
      )
      formData.set('image', this.form.profilePicture.file || '')

      const createCustomer = () =>
        CustomerService.create(formData).then(({ data }) => {
          const { result } = data

          const customer = {
            id: result.id,
            avatar: result.image.medium,
            firstName: result.first_name,
            lastName: result.last_name,
            tel: result.phone,
            idCardNumber: result.id_card_number
          }

          switch (this.$route.query.ref) {
            case 'sell':
              this.$store.commit('sell/SET_CUSTOMER', customer)
              break

            case 'buy':
              this.$store.commit('buy/SET_CUSTOMER', customer)
              break

            case 'trade':
              this.$store.commit('trade/SET_CUSTOMER', customer)
              break

            case 'pawn':
              this.$store.commit('pawn/SET_CUSTOMER', customer)
              break
          }
        })

      const updateCustomer = () => {
        if (!this.form.profilePicture.file) {
          formData.delete('image')
        }

        return CustomerService.patch(this.$route.params.id, formData).then(
          ({ data }) => {
            const { result } = data

            const customer = {
              id: result.id,
              avatar: result.image.medium,
              firstName: result.first_name,
              lastName: result.last_name,
              tel: result.phone,
              idCardNumber: result.id_card_number
            }

            switch (this.$route.query.ref) {
              case 'sell':
                this.$store.commit('sell/SET_CUSTOMER', customer)
                break

              case 'buy':
                this.$store.commit('buy/SET_CUSTOMER', customer)
                break

              case 'pawn':
                this.$store.commit('pawn/SET_CUSTOMER', customer)
                break
            }
          }
        )
      }

      let loading

      try {
        await this.$refs.form.validate()

        loading = useLoading()

        switch (this.mode) {
          case 'create':
            await createCustomer()
            break

          case 'edit':
            await updateCustomer()
            break
        }

        this.nextRoute()
      } catch (err) {
        if (
          err.responseMessage.detail &&
          Array.isArray(err.responseMessage.detail)
        ) {
          this.$notify.error({
            title: 'ข้อมูลไม่ถูกต้อง',
            dangerouslyUseHTMLString: true,
            message:
              '<ul>' +
              err.responseMessage.detail
                .map(item => {
                  return '<li>' + item + '</li>'
                })
                .join('') +
              '</ul>'
          })
        } else {
          this.$notify.error(err.message)
        }
      } finally {
        if (loading) {
          loading.close()
        }
      }
    },

    cancel() {
      this.nextRoute()
    },

    edit() {
      this.$router.replace({ name: 'CustomerEdit', query: this.$route.query })
    },

    dismiss() {
      this.nextRoute()
    },

    async querySubdistrict(queryString, cb) {
      if (queryString.trim().length < 3) return cb([])

      const { data } = await LocationService.getSubdistrict({
        name_th__contains: queryString
      })

      cb(
        data.result.map(item => ({
          id: item.subdistrict.id,
          subdistrict: item.subdistrict.name_th,
          district: item.district.name_th,
          province: item.province.name_th,
          postalCode: item.subdistrict.zip_code
        }))
      )
    },

    handleSubdistrictSelect(item) {
      this.location = item
      this.form.subdistrict = item.subdistrict
    },

    handleSubdistrictBlur() {
      if (this.location) {
        this.form.subdistrict = this.location.subdistrict
      }
    },

    handleSubdistrictClear() {
      this.location = null
      this.form.subdistrict = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.c-customer-create {
  &__header {
    text-align: center;
    margin-bottom: 2rem;
  }

  &__image-upload {
    max-width: 90px;
    border-radius: 50%;
    margin: 0 auto 0.5rem;
  }

  &__section-col {
    margin-bottom: 1rem;
  }

  &__section-heading {
    margin-bottom: 1rem;
  }

  &__section-content {
    border-left: 0.5rem solid #d8d8d8;
    padding: 1rem;
  }

  &__radio {
    width: 100%;
    display: flex;
    align-items: center;
    padding-top: 0;

    ::v-deep .el-radio__input {
      position: absolute;
      clip: rect(0, 0, 0, 0);
    }

    ::v-deep .el-radio__label {
      padding-left: 0;
    }
  }

  &__radio-icon {
    font-size: 1.5rem;
    font-weight: bold;
    vertical-align: middle;
  }
}
</style>
